import {NETWORKS} from "./configs";

export const getNetworksRpcs = () => {
    return Object.keys(NETWORKS).reduce((acc, networkKey) => {
        acc[networkKey] = NETWORKS[+networkKey].rpcUrls[0]
        return acc
    }, {} as { [key: string]: string })
}
